import {
  GET_APPROVAL_ORDER_ERROR,
  GET_APPROVAL_ORDER_REQUEST,
  GET_APPROVAL_ORDER_SUCCESS,
  RESET_APPROVAL_ORDER,
  UPDATE_APPROVAL_ORDER,
} from "redux/actions/action-type";

const initialState = {
  orders: [],
  metadata: [],
  errorDetails: {},
  isviewManualOrdersLoading: false,
  isviewManualOrdersError: false,
  isviewManualOrdersSuccess: false,
};

const approvalOrdersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_APPROVAL_ORDER_REQUEST:
      return {
        ...state,
        isviewManualOrdersLoading: true,
        isviewManualOrdersError: false,
        isviewManualOrdersSuccess: false,
      };

    case GET_APPROVAL_ORDER_SUCCESS:
      const { orders: newOrders, metadata: newMetadata } = payload;
      const { orders: existingOrders } = state;
      let mergedOrders;
      if (existingOrders) {
        mergedOrders = [...existingOrders, ...newOrders];
      } else {
        mergedOrders = newOrders;
      }

      return {
        ...state,
        isviewManualOrdersLoading: false,
        orders: mergedOrders,
        metadata: newMetadata,
        errorDetails: {},
        isviewManualOrdersError: false,
        isviewManualOrdersSuccess: true,
      };

    case GET_APPROVAL_ORDER_ERROR:
      return {
        ...state,
        errorDetails: payload,
        isviewManualOrdersLoading: false,
        isviewManualOrdersError: true,
        isviewManualOrdersSuccess: false,
      };

    case RESET_APPROVAL_ORDER:
      return {
        ...state,
        errorDetails: {},
        orders: [],
        metadata: [],
      };

    case UPDATE_APPROVAL_ORDER:
      const { orders } = payload;
      const { metadata } = state;
      return {
        ...state,
        isviewManualOrdersLoading: false,
        orders: orders,
        metadata: metadata,
        isviewManualOrdersError: false,
        isviewManualOrdersSuccess: true,
      };

    default:
      return state;
  }
};

export default approvalOrdersReducer;
